import { useState } from 'react';

export interface IRuleDisplayTemplate {
    ruleDisplayTemplate: string;
    setRuleDisplayTemplate: (value: string) => void;
    ruleDisplayTemplateError: boolean;
    setRuleDisplayTemplateError: (value: boolean) => void;
}

export default function useRuleDisplayTemplate(): IRuleDisplayTemplate {
    const [ruleDisplayTemplate, setRuleDisplayTemplate] = useState('');
    const [ruleDisplayTemplateError, setRuleDisplayTemplateError] = useState(false);

    return { ruleDisplayTemplate, setRuleDisplayTemplate, ruleDisplayTemplateError, setRuleDisplayTemplateError };
}
